import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {PROTO_GAME_PAGE} from "../constants/page_constants";

const useInactivityTimer = (timeout = 300000) => {
  // 5분 비활성 타이머 -> 아무런 동작 없으면 프로토 페이지로 이동
  const navigate = useNavigate();

  useEffect(() => {
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        navigate(PROTO_GAME_PAGE);
      }, timeout);
    };

    // 감지할 이벤트들
    const events = ['touchstart', 'touchmove', 'click'];

    // 모든 이벤트에 리스너 등록
    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    // 언마운트: 타이머와 이벤트 리스너 제거
    return () => {
      clearTimeout(timer);
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [navigate, timeout]);
};
export default useInactivityTimer;